import { useEffect, useRef, useState } from "react";
import { createUseStyles } from "react-jss";

// TODO: come up with better name

const PermaTooltip = ({ player, id, title, hide }) => {
  const classes = useStyles({ hide });
  const ref = useRef();

  useEffect(() => {
    if (player) {
      player.setTooltipLocation[id] = ({ left, top }) => {
        if (ref.current) {
          ref.current.style.left = `${left}px`;
          ref.current.style.top = `${top}px`;
        }
      };
      return () => {
        delete player.setTooltipLocation[id];
      };
    }
  }, [id, player]);

  return (
    <div className={classes.tooltip} ref={ref}>
      {title}
    </div>
  );
};

const PermaTooltips = ({ player, hide = false }) => {
  const [tooltips, setTooltips] = useState([]);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const classes = useStyles({ hide: isTransitioning });

  useEffect(() => {
    if (player) {
      player.setTooltips = setTooltips;
      player.setIsTransitioning = setIsTransitioning;
      player.findTooltips();

      return () => {
        player.setTooltips = () => {};
        player.isTransitioning = () => {};
      };
    }
  }, [player]);

  return (
    <div className={classes.tooltips}>
      {tooltips.map(props => (
        <PermaTooltip key={props.id} player={player} hide={hide} {...props} />
      ))}
    </div>
  );
};

const useStyles = createUseStyles({
  tooltips: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: 10,
    transition: "opacity 0.2s ease",
    opacity: props => (props.hide ? 0 : 1),
  },
  tooltip: {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    padding: [3, 10],
    borderRadius: 3,
    transform: "translate(-50%, -50px)",
    whiteSpace: "nowrap",
    lineHeight: "initial",
    transition: "opacity 0.2s ease",
    opacity: props => (props.hide ? 0 : 1),
  },
});

export default PermaTooltips;
